import React from "react";
import { toast } from "react-toastify";
import CustomButton from "../custom-button";

const CustomToast = ({ type, messageTitle, Body, showDismissButton, customButtons }) => {
  const TitleTag = Body ? "h5" : "h6";

  var toastMainColor;
  switch (type) {
    case "error":
      toastMainColor = "red";
      break;
    case "success":
      toastMainColor = "green";
      break;
    case "info":
    default:
      toastMainColor = "primary";
      break;
  }

  return (
    <>
      <TitleTag className={`text-${toastMainColor} ${showDismissButton && "mb-2"}`}>
        {messageTitle}
      </TitleTag>
      {Body}
      {showDismissButton && (
        <div className="form-check float-right">
          <CustomButton
            onClick={() => toast.dismiss()}
            color={toastMainColor}
            text="Entendido"
            icon="thumbs-up"
          />
        </div>
      )}
      {customButtons}
    </>
  );
};

// Si se desea duplicar un toast del mismo tipo (por ej: dos toasts de tipo "Info"), se deben
// especificar IDs distintas al invocar el toast (variable toastId en 'toastOptions')
export const toasts = {
  error: ({ toastOptions, ...props }) =>
    toast.error(<CustomToast {...props} type="error" />, { ...toastOptions, toastId: "error" }),
  info: ({ toastOptions, ...props }) =>
    toast.info(<CustomToast {...props} type="info" />, { ...toastOptions, toastId: "info" }),
  success: ({ toastOptions, ...props }) =>
    toast.success(<CustomToast {...props} type="success" />, {
      ...toastOptions,
      toastId: "success",
    }),
};

export default toasts;
